import { z } from 'zod';
import {
  HOLIDAY_DESCRIPTION_MAX_LENGTH,
  HOLIDAY_NAME_MAX_LENGTH,
  MONTH_PARAM_PATTERN,
} from '../constants/holiday.constants';

const holidaySchema = z.object({
  id: z.number(),
  dateFrom: z.iso.date(),
  dateTo: z.iso.date(),
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
});

export const holidayListSchema = z.array(holidaySchema);

export const holidaySearchSchema = z.object({
  month: z.string().regex(MONTH_PARAM_PATTERN).optional().catch(undefined),
  date: z.iso.date().optional().catch(undefined),
});

export const holidayFormSchema = z
  .object({
    dateFrom: z.string().min(1, 'Pick the first day'),
    dateTo: z.string().min(1, 'Pick the last day'),
    name: z
      .string()
      .trim()
      .min(1, 'Write the holiday name')
      .max(HOLIDAY_NAME_MAX_LENGTH, `Name must be ${HOLIDAY_NAME_MAX_LENGTH} characters or fewer`),
    description: z
      .string()
      .trim()
      .max(
        HOLIDAY_DESCRIPTION_MAX_LENGTH,
        `Description must be ${HOLIDAY_DESCRIPTION_MAX_LENGTH} characters or fewer`,
      ),
    isActive: z.boolean(),
  })
  .refine((values) => values.dateTo >= values.dateFrom, {
    path: ['dateTo'],
    message: 'The last day cannot be before the first day',
  });

export type Holiday = z.infer<typeof holidaySchema>;
export type HolidayFormValues = z.infer<typeof holidayFormSchema>;

export interface HolidayPayload {
  dateFrom: string;
  dateTo: string;
  name: string;
  description: string;
  isActive: boolean;
}
